import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Podcasts from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.Podcasts = Podcasts;
// CLR aliases: PortableComponent.cshtml dispatches both PodcastBlock and PodcastSeries
// CMS content types through this same React component.
global.PodcastBlock = Podcasts;
global.PodcastSeries = Podcasts;
